import React, {memo} from "react";
import AmountTd from "../../../../Table/Common/AmountTd";

function Amount(props) {
    const { record } = props;

    // const currencyCode = useSelector(state => state.Report.reportData?.report?.currency_code);

    const { amount } = record;
    if (amount === '' || amount === undefined || amount === null)
        return null;

    return (
        <AmountTd amount={amount} doNotReadLists />
    );
}

export default memo(Amount);
